import $ from 'jquery';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Link, withRouter
} from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import services from '../../services/allservices.jsx';
import '../../stylesheet/signin.css';
import Loader from '../loader/loader.jsx';
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth';
import uuidv4 from 'uuid/v4';
const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};
const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved
})

const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },

})

class Signin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            userName: '',
            password: '',
            disabled: true,
            toggleType: "password",
            toggleText: "password",
            toggleIcon: "fa fa-eye-slash",
            togglePassIcon: "fa fa-eye-slash",
            // correctUsername: true,
            // correctPassword: true
        };

        this.onChange = this.onChange.bind(this)
        this.handleLogin = this.handleLogin.bind(this)
    }

    handleLogin(e) {

        // const {correctPassword ,correctUsername} = this.state
        // if (correctUsername === false) {
        //     this.setState({
        //         correctUsername: false
        //     })
        // }
        // else if (correctPassword === false) {
        //     this.setState({
        //         correctPassword: false
        //     })
        // }

        // else {
        this.setState({
            loader: true
        })
        // if (publicKey.status === 200) {
        //     const public_Key = publicKey.body.publickey;
        //     let encrypt = new JSEncrypt();
        //     encrypt.setPublicKey(public_Key);

        let _this = this
        let state = {
            userName: this.state.userName,
            password: this.state.password,
            mobileNumber: this.state.mobileNumber,
            applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
        }
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let gid = getClientId();
        let traceId = getClientId();
        fetch(plink + services.login, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gid,
                'clientSecret': getClientSecret(gid, this.state.userName),
                'X-Trace-Id': traceId,   
                'X-Client-APP':buildClientHeader(),
            }),
            body: JSON.stringify(state)
        })
            .then(
                function (response) {
                    if (response.status === 200 || response.status === 201) {

                        if (_this.state.userName === 'admin' && _this.state.password === 'Qwerty@1') {
                            response.json().then(function (json) {
                                let exp = json.expiryInMinutes

                                let expiry = (exp * 60000 + new Date().getTime())

                                localStorage.setItem('expiryTime', JSON.stringify(expiry))
                                localStorage.setItem("loginState", true)
                                localStorage.setItem('memberId', json.memberId);
                                localStorage.setItem('token', json.token)
                                localStorage.setItem('accountId', json.accountId);
                                localStorage.setItem('timeoutvalue', 'first')

                                localStorage.setItem('lastSuccessfulLogin', json.lastSuccessfulLogin);
                                localStorage.setItem('lastUnsuccessfulLogin', json.lastUnsuccessfulLogin);
                                localStorage.setItem('cardTypes', json.cardTypes)
                                localStorage.setItem('newPhysicalCardRequested', json.newPhysicalCardRequested)

                                _this.setState({
                                    loader: false
                                })
                                toast.success(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });

                                setTimeout(function () {
                                    _this.props.history.push('/cardsearch');

                                }, 3000);
                            })
                        }
                        else {
                            response.json().then(function (json) {
                                let exp = json.expiryInMinutes

                                let expiry = (exp * 60000 + new Date().getTime())

                                localStorage.setItem('expiryTime', JSON.stringify(expiry))
                                localStorage.setItem("loginState", true)
                                localStorage.setItem('memberId', json.memberId);
                                localStorage.setItem('token', json.token)
                                localStorage.setItem('accountId', json.accountId);
                                localStorage.setItem('cardTypes', json.cardTypes)
                                localStorage.setItem('lastSuccessfulLogin', json.lastSuccessfulLogin);
                                localStorage.setItem('lastUnsuccessfulLogin', json.lastUnsuccessfulLogin);
                                localStorage.setItem('newPhysicalCardRequested', json.newPhysicalCardRequested)
                                if (json.performChangePassword === true) {
                                    setTimeout(function () {
                                        _this.props.history.push('/fchangepassword');
                                    }, 3000);
                                }
                                else if (json.performForceSecretQuestion === true) {
                                    setTimeout(function () {
                                        _this.props.history.push('/ForceChangesecretque');
                                    }, 3000);
                                }
                                else {
                                    _this.setState({
                                        loader: false
                                    })
                                    toast.success(response.headers.get('message'), {
                                        position: "top-right",
                                        draggablePercent: 60,
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: false
                                    });

                                    setTimeout(function () {
                                        _this.props.history.push('/home');
                                        localStorage.setItem("landing", false)
                                    }, 3000);


                                }



                                // _this.props.history.push('/home');
                            })
                        }
                    }
                    else if (response.status === 417) {
                        _this.setState({
                            loader: false
                        })
                        document.getElementById("myModal").style.display = "block"

                    }
                    else if (response.status === 422) {
                        response.json()
                            .then(json => {
                                let message = json.message ? json.message : response.headers.get('message')
                                //document.getElementById('setpassword').style.display = "block"
                                toast.error(message, {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    draggablePercent: 60
                                })
                                _this.setState({
                                    loader: false
                                })
                                // setTimeout(function () { window.location.reload(true) }, 100) 
                            })
                    }
                    else {
                        _this.setState({
                            loader: false
                        })

                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                        // setTimeout(function () { window.location.reload(true) }, 100)
                    }
                }
            )
        // }
    }
    handleClose = () => {
        document.getElementById("myModal").style.display = "none"
        window.scrollBy(0, 750)
    }
    onEnterPress = (e) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            e.preventDefault();
            this.handleLogin();
        }
    }

    handelvalidateusername = (e, value) => {
        if (e.target.name === "userName" && value.length !== 0) {
            $(function () {
                $('#uName').on('keypress', function (e) {

                    if (e.which === 32)
                        return false;
                });
            });
            // if ((e.target.value.length) >= 6) {
            this.setState({
                userName: value
            }, () => {
                if (this.state.userName.length !== 0 && this.state.password.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
            // }else {
            //     this.setState({
            //         correctUsername: false
            //     })
            // }
        } else {
            this.setState({
                disabled: true
            })
        }
    }

    handelvalidatepassword = (e, value) => {
        if (e.target.name === "password" && value.length !== 0) {
            // if ((e.target.value.length) >= 8) {
            this.setState({
                password: value
            }, () => {
                if (this.state.userName.length !== 0 && this.state.password.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
            // }else {
            //     this.setState({
            //         correctPassword: false
            //     })
            // }
        } else {
            this.setState({
                disabled: true
            })
        }
    }
    onChange(e, value) {
        this.setState({
            [e.target.name]: value
        })

    }

    handelmobileNumber = (e, value) => {
        // let addval=  value.trim()

        this.setState({
            mobileNumber: value
        }, () => {
            if (/^\d{3,20}$/.test(e.target.value)) {
                this.setState({ validmobileNumber: true })
            } else {
                this.setState({
                    mobileNumber: '',
                    validmobileNumber: false
                })
            }
        })

    }

    toggle = () => {

        if (this.state.toggleType === "password") {
            this.setState({
                toggleType: "text",
                toggleIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                toggleType: "password",
                toggleIcon: "fa fa-eye-slash"
            })
        }
    }
    togglepassword = () => {
        if (this.state.toggleText === "password") {
            this.setState({
                toggleText: "text",
                togglePassIcon: "fa fa-fw fa-eye"
            })
        } else {
            this.setState({
                toggleText: "password",
                togglePassIcon: "fa fa-eye-slash"
            })
        }
    }


    componentDidMount() {

        if (localStorage.getItem('landingTabs') !== 'cardNo') {

            document.getElementById("uName").focus()
        }
        $(".toggle-password").click(function () {

            $(this).toggleClass("fa-eye fa-eye-slash");
            var input = $($(this).attr("toggle"));
            if (input.attr("type") === "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });
    }
    render() {
        const { loader } = this.state


        return (
            <div>

                {loader ? <div>
                    <Loader />
                </div> :
                    <div>
                        <div className="row input-group" >
                            <div className="offset-md-1 col-sm-2 signinput" >
                                <i className="fa fa-user text-dark " aria-hidden="true"></i>
                            </div>
                            <div className="col-sm-9" >
                                <TextField
                                    hintText="User ID"
                                    floatingLabelText="User ID"
                                    id="uName"
                                    type="text"
                                    name="userName"
                                    maxLength="20"
                                    autoComplete='off'
                                    onKeyDown={this.onEnterPress}
                                    onChange={this.handelvalidateusername}
                                    className="my-className"
                                    underlineFocusStyle={styles.focusStyle}
                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                    autoFocus={this.props.autoFocus}
                                />
                            </div>
                        </div>
                        <div className="row input-group" >
                            <div className="offset-md-1 col-sm-2 signinput" >
                                <i className="fa fa-key text-dark " aria-hidden="true"></i>
                            </div>
                            <div className="col-sm-9" >
                                <TextField
                                    hintText="Type Your Password"
                                    floatingLabelText="Password"
                                    type={this.state.toggleType}
                                    name="password"
                                    id="loginpassword"
                                    autoComplete='none'
                                    maxLength="15"
                                    onKeyDown={this.onEnterPress}
                                    onChange={this.handelvalidatepassword}
                                    underlineFocusStyle={styles.focusStyle}
                                    floatingLabelFocusStyle={styles.focusTextStyle}

                                />
                                {/* <span toggle="#loginpassword" style={{ marginTop: "40px", position: "absolute" }} className="fa fa-fw fa-eye-slash signinput toggle-password " ></span> */}
                                <span toggle="#loginpassword" className={`${this.state.toggleIcon} field-icon toggle-password`} style={{ marginTop: "40px", right: "-5px", cursor: "pointer" }} onClick={this.toggle} ></span>
                            </div>
                        </div>
                        <div className="row input-group" >
                            <div className="offset-md-1 col-sm-2 signinput" >
                                <i className="fa fa-mobile text-dark " aria-hidden="true" style={{ fontSize: "34px", right: "-7px" }}></i>
                            </div>
                            <div className="col-sm-6" >
                                <TextField
                                    hintText="Start Typing"
                                    floatingLabelText="Mobile Number"
                                    type="text"
                                    name="mobileNumber"
                                    maxLength="20"
                                    // onInput={(e) => {
                                    //     e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 15)
                                    // }}
                                    autoComplete='none'
                                    className="input-width"
                                    onChange={this.handelmobileNumber.bind(this)}
                                    onFocus={this.removephone}
                                    underlineFocusStyle={styles.focusStyle}
                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                    errorText={this.state.validmobileNumber ? null : "Not a valid phone number"}
                                />
                                {/* <span toggle="#loginpassword" style={{marginTop:"40px",position:"absolute"}}className="fa fa-fw fa-eye signinput toggle-password " ></span> */}
                            </div>
                        </div>
                        <div className="row input-group"  >

                            <div className="offset-md-5 col-sm-3" style={{ marginTop: '20px' }} >
                                <RaisedButton
                                    label="Sign In"
                                    disabled={this.state.disabled}
                                    type="submit"
                                    className="card-submit btn-std"
                                    backgroundColor="#FFCE39"
                                    labelColor="#115876"
                                    onClick={this.handleLogin}
                                    icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                />
                            </div>
                        </div>

                        <div className="row input-group"  >
                            <div className="col-sm-11" style={{ padding: "8px 0px 0px 90px" }} >
                                <div className="row"  >
                                    <div ><Link to='/forgotpassword' style={{ fontSize: "12px", fontWeight: "600", color: "#333", marginRight: "20px" }}> Forgot Your Password</Link></div>
                                    <div ><Link to='/forgotuserid' style={{ fontSize: "12px", fontWeight: "600", color: "#333", marginRight: "20px" }}> Forgot Your User ID</Link></div>
                                    <div ><Link to='/resetquestion' style={{ fontSize: "12px", fontWeight: "600", color: "#333" }}> Reset Secret Q&A</Link></div>
                                </div>
                            </div>
                        </div>
                    </div>

                }

                <div className="col-sm-12 modal-for-login flowmodal" id="myModal" style={{ display: "none" }}>
                    <div className="modal-content col-sm-4" style={{ background: "rgb(214, 70, 84)" }}>
                        <div className="modal-header" style={{ borderBottom: "none", height: "45px" }}>
                            <div className="col-sm-12" style={{ marginTop: "-7px" }}>
                                <div className="row">
                                    <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                        <span>Error</span>
                                    </div>
                                    <div className="offset-4 col-sm-2" style={{ float: "right" }}>
                                        <button type="button" className="close" data-dismiss="modal" style={{ marginTop: "-19px" }} onClick={this.handleClose.bind(this)} aria-label="Close">
                                            <span aria-hidden="true" style={{ color: "#fff", fontSize: "22px" }}>&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                            <div className="col-sm-12" >
                                <i className="fa fa-times fa-4x mb-3 animated rotateIn" style={{ color: "rgb(214, 70, 84)" }}></i>
                            </div>
                            <div className="col-sm-12" style={{ fontSize: "20px" }}>
                                <span>Your card is either Closed or Fraud Blocked. For assistance please send us an email from the Contact Us tab.</span>
                            </div>
                            <div className="col-sm-12" >
                                <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)" }}
                                    onClick={this.handleClose.bind(this)}
                                    aria-label="Close">
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Signin));


// WEBPACK FOOTER //
// ./src/components/register/signin.jsx